import axios from "axios";
import { getRealPath } from "@/utils/utils";
import responseHandle from "../utils/responseHandler";
import errorResponseHandler from "../utils/errorResponseHandler";
import qs from "qs";
import actions from "@/store/shardActions";

// import store from "@/store";

const defaultUrl = getRealPath();
console.log(process.env.NODE_ENV);
const service = axios.create({
  baseURL:
    process.env.NODE_ENV == "development"
      ? process.env.VUE_APP_ROOT
      : defaultUrl + window.HS_CONFIG.gateway,
  // withCredentials: true
});

service.interceptors.request.use((config) => {
  const requestBody = {};
  let deleteUrl = "/v2/article/";
  if (
    config.method.toUpperCase() === "GET" ||
    (config.method.toUpperCase() === "DELETE" &&
      config.url.indexOf(deleteUrl) == -1)
  ) {
    config.paramsSerializer = function (params) {
      return qs.stringify(params, { arrayFormate: "repeat" });
    };
    requestBody.params = config.data;
    config.params = requestBody.params;
  }
  let token = actions.getGlobalState("accessToken");
  //   后台认证之后返回accessToken 之后的每次请求把accessToken放在header里
  if (![null, "null", undefined, "undefined", NaN, "NaN"].includes(token)) {
    config.headers["Authorization"] = "Bearer " + token;
  }
  return config;
});

service.interceptors.response.use(
  (response) => {
    // 文件下载
    if (response.config && response.config.responseType == "blob") {
      const filenameRX = /(?:fileName|filename)=(.*)$/;
      const filennameARX = /(?:fileName\*|filename\*)=(.*)$/;
      const type = response.headers["content-type"];
      const blob = new Blob([response.data], { type });
      let filenameData =
        response.headers["content-disposition"].match(filennameARX) ??
        response.headers["content-disposition"].match(filenameRX);
      let splitFileData = filenameData[1].split("''");
      let filename = splitFileData[1]
        ? decodeURI(splitFileData[1])
        : filenameData[1];
      if ("download" in document.createElement("a")) {
        const downloadElement = document.createElement("a");
        let href = "";
        if (window.URL) href = window.URL.createObjectURL(blob);
        else href = window.webkitURL.createObjectURL(blob);
        downloadElement.href = href;
        downloadElement.download = filename;
        document.body.appendChild(downloadElement);
        downloadElement.click();
        if (window.URL) window.URL.revokeObjectURL(href);
        else window.webkitURL.revokeObjectURL(href);
        document.body.removeChild(downloadElement);
      } else {
        navigator.msSaveBlob(blob, filename);
      }
      return response;
    }
    responseHandle(response);
    return response.data;
  },
  (error) => {
    console.log(error);
    errorResponseHandler(error.response);
    return Promise.reject(error);
  }
);

export default service;
